export const UserActionTypes = {
    LOGIN_USER_REQUEST: 'LOGIN_USER_REQUEST',
    LOGIN_USER_SUCCESS: 'LOGIN_USER_SUCCESS',
    LOGIN_USER_ERROR: 'LOGIN_USER_ERROR',

    EMPLOYEE_LOGIN_REQUEST: 'EMPLOYEE_LOGIN_REQUEST',

    CUSTOMER_LOGIN_REQUEST: 'CUSTOMER_LOGIN_REQUEST',
    CUSTOMER_LOGIN_REQUEST_SUCCESS: 'CUSTOMER_LOGIN_REQUEST_SUCCESS',
    CUSTOMER_LOGIN_REQUEST_ERROR: 'CUSTOMER_LOGIN_REQUEST_ERROR',

    REGISTER_REQUEST: 'REGISTER_REQUEST',
    REGISTER_REQUEST_SUCCESS: 'REGISTER_REQUEST_SUCCESS',
    REGISTER_REQUEST_ERROR: 'REGISTER_REQUEST_ERROR',
    REGISTER_REQUEST_STATUS: 'REGISTER_REQUEST_STATUS',

    FORGOT_PASSWORD_REQUEST: 'FORGOT_PASSWORD_REQUEST',
    FORGOT_PASSWORD_REQUEST_SUCCESS: 'FORGOT_PASSWORD_REQUEST_SUCCESS',
    FORGOT_PASSWORD_REQUEST_ERROR: 'FORGOT_PASSWORD_REQUEST_ERROR',
    FORGOT_PASSWORD_REQUEST_STATUS: 'FORGOT_PASSWORD_REQUEST_STATUS',

    CHANGE_PASSWORD_REQUEST: 'CHANGE_PASSWORD_REQUEST',
    CHANGE_PASSWORD_REQUEST_SUCCESS: 'CHANGE_PASSWORD_REQUEST_SUCCESS',
    CHANGE_PASSWORD_REQUEST_ERROR: 'CHANGE_PASSWORD_REQUEST_ERROR',
    CHANGE_PASSWORD_REQUEST_STATUS: 'CHANGE_PASSWORD_REQUEST_STATUS',

    LOGOUT: 'LOGOUT',

    COUNTRY_LIST_REQUEST: 'COUNTRY_LIST_REQUEST',
    COUNTRY_LIST_REQUEST_SUCCESS: 'COUNTRY_LIST_REQUEST_SUCCESS',
    COUNTRY_LIST_REQUEST_ERROR: 'COUNTRY_LIST_REQUEST_ERROR',

    STATE_LIST_REQUEST: 'STATE_LIST_REQUEST',
    STATE_LIST_REQUEST_SUCCESS: 'STATE_LIST_REQUEST_SUCCESS',
    STATE_LIST_REQUEST_ERROR: 'STATE_LIST_REQUEST_ERROR',

    CITY_LIST_REQUEST: 'CITY_LIST_REQUEST',
    CITY_LIST_REQUEST_SUCCESS: 'CITY_LIST_REQUEST_SUCCESS',
    CITY_LIST_REQUEST_ERROR: 'CITY_LIST_REQUEST_ERROR',

    RESET_STATE_CITY: 'RESET_STATE_CITY',

    DISPLAY_SIDE_BAR: 'DISPLAY_SIDE_BAR',

    COMMON_ERROR: 'COMMON_ERROR',

    OPERATOR_REGISTRATION_REQUEST: 'OPERATOR_REGISTRATION_REQUEST',
    OPERATOR_REGISTRATION_REQUEST_SUCCESS: 'OPERATOR_REGISTRATION_REQUEST_SUCCESS',
    OPERATOR_REGISTRATION_REQUEST_ERROR: 'OPERATOR_REGISTRATION_REQUEST_ERROR',
    OPERATOR_REGISTRATION_REQUEST_STATUS: 'OPERATOR_REGISTRATION_REQUEST_STATUS',

    OPERATOR_LIST_REQUEST: 'OPERATOR_LIST_REQUEST',
    OPERATOR_LIST_REQUEST_SUCCESS: 'OPERATOR_LIST_REQUEST_SUCCESS',
    OPERATOR_LIST_REQUEST_ERROR: 'OPERATOR_LIST_REQUEST_ERROR',

    OPERATOR_DETAIL_REQUEST: 'OPERATOR_DETAIL_REQUEST',
    OPERATOR_DETAIL_REQUEST_SUCCESS: 'OPERATOR_DETAIL_REQUEST_SUCCESS',
    OPERATOR_DETAIL_REQUEST_ERROR: 'OPERATOR_DETAIL_REQUEST_ERROR',

    UPDATE_OPERATOR_LOCATIONS_REQUEST: 'UPDATE_OPERATOR_LOCATIONS_REQUEST',
    UPDATE_OPERATOR_LOCATIONS_REQUEST_SUCCESS: 'UPDATE_OPERATOR_LOCATIONS_REQUEST_SUCCESS',
    UPDATE_OPERATOR_LOCATIONS_REQUEST_ERROR: 'UPDATE_OPERATOR_LOCATIONS_REQUEST_ERROR',
    UPDATE_OPERATOR_LOCATIONS_REQUEST_STATUS: 'UPDATE_OPERATOR_LOCATIONS_REQUEST_STATUS',

    UPDATE_USER_NOTIFICATION_TOKEN_REQUEST: 'UPDATE_USER_NOTIFICATION_TOKEN_REQUEST',
    UPDATE_USER_NOTIFICATION_TOKEN_REQUEST_SUCCESS: 'UPDATE_USER_NOTIFICATION_TOKEN_REQUEST_SUCCESS',
    UPDATE_USER_NOTIFICATION_TOKEN_REQUEST_ERROR: 'UPDATE_USER_NOTIFICATION_TOKEN_REQUEST_ERROR',
    UPDATE_USER_NOTIFICATION_TOKEN_REQUEST_STATUS: 'UPDATE_USER_NOTIFICATION_TOKEN_REQUEST_STATUS',

    UPDATE_SELECTED_LOCATION: 'UPDATE_SELECTED_LOCATION',

    EMPLOYEE_BUSINESS_LOCATION_SELECTION: 'EMPLOYEE_BUSINESS_LOCATION_SELECTION',

    SHOW_HIDE_NAV_MENU_OPTION: 'SHOW_HIDE_NAV_MENU_OPTION',

    EMPLOYEE_CHANGE_PASSWORD_REQUEST: 'EMPLOYEE_CHANGE_PASSWORD_REQUEST',
    EMPLOYEE_CHANGE_PASSWORD_REQUEST_SUCCESS: 'EMPLOYEE_CHANGE_PASSWORD_REQUEST_SUCCESS',
    EMPLOYEE_CHANGE_PASSWORD_REQUEST_ERROR: 'EMPLOYEE_CHANGE_PASSWORD_REQUEST_ERROR',
    EMPLOYEE_CHANGE_PASSWORD_REQUEST_STATUS: 'EMPLOYEE_CHANGE_PASSWORD_REQUEST_STATUS',

    USER_LIST_REQUEST: 'USER_LIST_REQUEST',
    USER_LIST_REQUEST_SUCCESS: 'USER_LIST_REQUEST_SUCCESS',
    USER_LIST_REQUEST_ERROR: 'USER_LIST_REQUEST_ERROR',

    RENEW_TRAIL_SUBSCRIPTION_REQUEST: 'RENEW_TRAIL_SUBSCRIPTION_REQUEST',
    RENEW_TRAIL_SUBSCRIPTION_REQUEST_SUCCESS: 'RENEW_TRAIL_SUBSCRIPTION_REQUEST_SUCCESS',
    RENEW_TRAIL_SUBSCRIPTION_REQUEST_ERROR: 'RENEW_TRAIL_SUBSCRIPTION_REQUEST_ERROR',
    RENEW_TRAIL_SUBSCRIPTION_REQUEST_STATUS: 'RENEW_TRAIL_SUBSCRIPTION_REQUEST_STATUS',

    UPDATE_TRANSACTION_STATUS_REQUEST_SUCCESS: 'UPDATE_TRANSACTION_STATUS_REQUEST_SUCCESS'
}
